import { IconCollection as sharedIcons } from '@aspid/ui';

import { appIcons } from './appIcons';

/**
 * Набор иконок приложения: общий из `@aspid/ui` плюс своё расширение.
 *
 * Расширение идёт вторым — приложение может перекрыть общее имя, если у него
 * есть на то доменная причина (AF-19). Такие случаи объявляются в
 * `appIcons.ts` с комментарием, почему.
 *
 * Отдельный модуль, а НЕ барель `index.tsx`, — намеренно. Барель реэкспортирует
 * компоненты-иконки, а те импортируют коллекцию; если коллекция живёт в бареле,
 * получается цикл `AlertIcon → AlertIcon/index → icons/index → AlertIcon`.
 * Сборка падает на `vite-plugin-circular-dependency`, а typecheck и тесты этого
 * не видят. Барель остаётся точкой входа для внешних потребителей, источником
 * коллекции — этот файл: одна роль на модуль.
 */
export const IconCollection = { ...sharedIcons, ...appIcons };
